import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { getLastComment } from '@helpers';
import TextTypography from '../Typography/Text';
import { ILeadCreditEntity, ILeadEntity, LeadStatusEnum, transformToFormattedTime } from '@rasayi-workspace/shared';
import { optionalColumnsType } from '../types';

export const UserIdColumn = {
    title: 'User ID',
    dataIndex: 'id',
    key: 'id',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (_: string) => (
        <Tooltip title={_}>
            <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[134px]">
                {_}
            </TextTypography>
        </Tooltip>
    ),
};

export const AgentColumn = {
    title: 'Agent',
    key: 'user.first_name',
    ellipsis: true,
    sorter: () => 0,
    render: (_: string, item: ILeadEntity) => {
        const name = item.user?.first_name;
        return (
            <Tooltip title={name}>
                <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] items-center w-[120px]">
                    {name}
                </TextTypography>
            </Tooltip>
        );
    },
};

export const FirstNameColumn = {
    title: 'First Name',
    dataIndex: 'first_name',
    key: 'first_name',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (_: string) => (
        <Tooltip title={_}>
            <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[120px]">
                {_}
            </TextTypography>
        </Tooltip>
    ),
};

export const LastNameColumn = {
    title: 'Last Name',
    dataIndex: 'last_name',
    key: 'last_name',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (_: string) => (
        <Tooltip title={_}>
            <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[120px]">
                {_}
            </TextTypography>
        </Tooltip>
    ),
};

export const EmailColumn = {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (_: string) => (
        <Tooltip title={_}>
            <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[218px]">
                {_}
            </TextTypography>
        </Tooltip>
    ),
};

export const PhoneColumn = {
    title: 'Phone Number',
    dataIndex: 'phone',
    key: 'phone',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (_: string) => (
        <Tooltip title={_}>
            <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[159px]">
                {_}
            </TextTypography>
        </Tooltip>
    ),
};

export const SecondaryPhoneColumn = {
    title: 'Secondary Phone',
    dataIndex: 'secondary_phone',
    key: 'secondary_phone',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (_: string) => (
        <Tooltip title={_}>
            <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[159px]">
                {_}
            </TextTypography>
        </Tooltip>
    ),
};

export const CnicColumn = {
    title: 'CNIC',
    dataIndex: 'cnic_number',
    key: 'cnic_number',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (_: string) => (
        <Tooltip title={_}>
            <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[160px]">
                {_}
            </TextTypography>
        </Tooltip>
    ),
};

export const LeadStatusColumn = {
    title: 'Status',
    dataIndex: 'lead_status',
    key: 'lead_status',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (status: string | LeadStatusEnum) => (
        <div className="h-[40px] w-[146px]">
            <TextTypography fontSize={14} classNames={`cursor-pointer flex  truncate items-center  !px-[8px] !py-[6px]  rounded-lg !w-fit`}>
                {status}
            </TextTypography>
        </div>
    ),
};

export const CityColumn = {
    title: 'City',
    dataIndex: 'city',
    key: 'city',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (_: string) => (
        <Tooltip title={_}>
            <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[146px]">
                {_}
            </TextTypography>
        </Tooltip>
    ),
};

export const OrganizationColumn = {
    title: 'Organization',
    dataIndex: 'organization',
    key: 'organization',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (_: string) => (
        <Tooltip title={_}>
            <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[172px]">
                {_}
            </TextTypography>
        </Tooltip>
    ),
};

export const SegmentColumn = {
    title: 'Segment',
    dataIndex: 'segment',
    key: 'segment',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (_: string) => (
        <Tooltip title={_}>
            <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[124px]">
                {_}
            </TextTypography>
        </Tooltip>
    ),
};

export const ChannelColumn = {
    title: 'Channel',
    key: 'channel.name',
    ellipsis: true,
    sorter: () => 0,
    render: (_: string, item: ILeadEntity) => {
        const channel = item.channel?.name;

        return (
            <Tooltip title={channel}>
                <TextTypography fontSize={16} classNames="cursor-pointer flex  h-[40px] truncate items-centerw-[140px]">
                    {channel}
                </TextTypography>
            </Tooltip>
        );
    },
};

export const EMIColumn = {
    title: 'EMI',
    dataIndex: 'credit',
    key: 'credit',
    ellipsis: true,
    sorter: () => 0,
    render: (credit: ILeadCreditEntity) => {
        return (
            <Tooltip title={credit?.emi}>
                <TextTypography fontSize={16} classNames="cursor-pointer flex  h-[40px] truncate items-centerw-[140px]">
                    {credit?.emi}
                </TextTypography>
            </Tooltip>
        );
    },
};

export const CreatedAtColumn = {
    title: 'Created At',
    dataIndex: 'created_at',
    key: 'created_at',
    ellipsis: true,
    render: (value: string) => (
        <TextTypography fontSize={16} classNames="cursor-pointer flex w-[179px] h-[40px] truncate items-center">
            {transformToFormattedTime(value)}
        </TextTypography>
    ),
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
};

export const CommentColumn = {
    title: 'Comment',
    dataIndex: 'comments?.[0].text',
    key: 'comments?.[0].text',
    ellipsis: true,
    sorter: () => 0,
    sortDirections: ['ascend', 'descend'] as ['ascend', 'descend'],
    render: (_: string, item: ILeadEntity) => (
        <Tooltip>
            <TextTypography fontSize={16} classNames="cursor-pointer flex h-[40px] truncate items-center w-[301px]">
                {getLastComment(item)}
            </TextTypography>
        </Tooltip>
    ),
};

export const createColumns = (optionalColumns?: optionalColumnsType): ColumnsType<ILeadEntity> => {
    let columns: ColumnsType<ILeadEntity> = [];
    if (optionalColumns?.includes('all')) {
        columns = [
            UserIdColumn,
            AgentColumn,
            FirstNameColumn,
            LastNameColumn,
            EmailColumn,
            PhoneColumn,
            SecondaryPhoneColumn,
            CnicColumn,
            LeadStatusColumn,
            CityColumn,
            OrganizationColumn,
            SegmentColumn,
            ChannelColumn,
            EMIColumn,
            CreatedAtColumn,
            CommentColumn,
        ];
    } else {
        if (optionalColumns?.includes('id')) columns.push(UserIdColumn);
        if (optionalColumns?.includes('agent')) columns.push(AgentColumn);
        if (optionalColumns?.includes('first_name')) columns.push(FirstNameColumn);
        if (optionalColumns?.includes('last_name')) columns.push(LastNameColumn);
        if (optionalColumns?.includes('email')) columns.push(EmailColumn);
        if (optionalColumns?.includes('phone')) columns.push(PhoneColumn);
        if (optionalColumns?.includes('secondary_phone')) columns.push(SecondaryPhoneColumn);
        if (optionalColumns?.includes('cnic')) columns.push(CnicColumn);
        if (optionalColumns?.includes('lead_status')) columns.push(LeadStatusColumn);
        if (optionalColumns?.includes('city')) columns.push(CityColumn);
        if (optionalColumns?.includes('organization')) columns.push(OrganizationColumn);
        if (optionalColumns?.includes('segment')) columns.push(SegmentColumn);
        if (optionalColumns?.includes('channel')) columns.push(ChannelColumn);
        if (optionalColumns?.includes('emi')) columns.push(EMIColumn);
        if (optionalColumns?.includes('created_at')) columns.push(CreatedAtColumn);
        if (optionalColumns?.includes('comment')) columns.push(CommentColumn);
    }

    return columns;
};
